import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "body",
  class: "basic"
}
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "width-wrap" }
const _hoisted_4 = { class: "width-wrap" }
const _hoisted_5 = { class: "page-content section" }
const _hoisted_6 = {
  id: "estateAgentProfile-form",
  class: "form",
  autocomplete: "off"
}
const _hoisted_7 = { class: "form-header" }
const _hoisted_8 = { class: "form-section has-aside" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "form-field readonly" }
const _hoisted_11 = { for: "frm-estateAgentProfileForm_firstName" }
const _hoisted_12 = { class: "form-field readonly" }
const _hoisted_13 = { for: "frm-estateAgentProfileForm_lastName" }
const _hoisted_14 = { class: "form-field readonly" }
const _hoisted_15 = { for: "frm-estateAgentProfileForm_email" }
const _hoisted_16 = { class: "form-field readonly" }
const _hoisted_17 = { for: "frm-estateAgentProfileForm_phoneNumber" }
const _hoisted_18 = {
  key: 0,
  class: "form-field readonly full-width"
}
const _hoisted_19 = { for: "frm-estateAgentProfileForm_motto" }
const _hoisted_20 = {
  key: 1,
  class: "form-field readonly full-width"
}
const _hoisted_21 = { for: "frm-estateAgentProfileForm_description" }
const _hoisted_22 = {
  key: 2,
  class: "form-field readonly full-width"
}
const _hoisted_23 = { for: "frm-estateAgentProfileForm_languages" }
const _hoisted_24 = { class: "form-section-aside" }
const _hoisted_25 = { class: "form-field" }
const _hoisted_26 = { class: "photo is-preview" }
const _hoisted_27 = {
  key: 0,
  class: "company-logo"
}
const _hoisted_28 = { class: "form-footer" }
const _hoisted_29 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EstateAgentLanguage = _resolveComponent("EstateAgentLanguage")!
  const _component_ResizableImage = _resolveComponent("ResizableImage")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('EstateAgentProfile.title')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("form", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.$t('EstateAgentProfile.form-header')), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('EstateAgentProfile.firstName')) + ":", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.profile.firstName), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('EstateAgentProfile.lastName')) + ":", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.profile.lastName), 1)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('EstateAgentProfile.email')) + ":", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.profile.email), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('EstateAgentProfile.phoneNumber')) + ":", 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.profile.fullPhoneNumber), 1)
              ]),
              (_ctx.profile.motto)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('EstateAgentProfile.motto')) + ":", 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.profile.motto), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.profile.description)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t('EstateAgentProfile.description')) + ":", 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.profile.description), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.profile.languages && _ctx.profile.languages.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('EstateAgentProfile.languages')) + ":", 1),
                    _createVNode(_component_EstateAgentLanguage, {
                      languages: _ctx.profile.languages
                    }, null, 8, ["languages"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(_component_ResizableImage, {
                    url: _ctx.profile.photoRelativeUrl,
                    placeholder: "img/no-photo-user.png",
                    width: 220,
                    height: 220,
                    alt: _ctx.profile.lastName
                  }, null, 8, ["url", "alt"])
                ]),
                (_ctx.profile.logo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createVNode(_component_ResizableImage, {
                        classes: "estate-agency-logo",
                        url: _ctx.profile.logoRelativeUrl,
                        width: 240,
                        height: 135
                      }, null, 8, ["url"])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createVNode(_component_router_link, {
                to: { name: 'UserProfileEdit' },
                tag: "button",
                class: "button button--primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('EstateAgentProfile.button-edit')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                to: { name: 'ChangePassword' },
                tag: "button",
                class: "button button--primary reversed"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('EstateAgentProfile.button-change-password')), 1)
                ]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}